<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-header">
                    <h5> Add User </h5>
                </div>
                <div class="card-body tab2-card">
                    <form [formGroup]="addUserForm">
                        <div class="mb-3">

                            <button class="btn btn-primary me-1 mb-3" style="float: right;"
                                    (click)="moveToMainPage()">Back
                            </button>
                        </div>

                        <div class="mb-sm-4 col-3">
                            <label>Username</label>
                            <input type='text' class="filter-ngx form-control" placeholder='username'
                                   formControlName="username">

                        </div>

                        <div class="mb-sm-4 col-3">
                            <label>Mobile Number</label>
                            <input type='text' class="filter-ngx form-control" placeholder='mobilenumber'
                                   formControlName='mobilenumber'>

                        </div>

                        <label>Status<span class="text-danger">*</span></label>
                        <select class="form-select form-control" formControlName="status">
                            <option [ngValue]="1">Enable</option>
                            <option [ngValue]="0">Disable</option>
                            <option *ngFor="let item of status"
                                    [ngValue]="item.status">{{item.status}}</option>
                        </select>
                        <br>
                        <label>Blocked Message<span class="text-danger">*</span></label>
                        <select class="form-select form-control" formControlName="blocked_message">
                            <option [ngValue]="1">Yes</option>
                            <option [ngValue]="0">No</option>
                            <option *ngFor="let item of blocked_add_channel">
                                [ngValue]="item.blocked_message">{{item.blocked_message}}</option>
                        </select>
                        <br>
                        <label>Blocked Add Channel<span class="text-danger">*</span></label>
                        <select class="form-select form-control" formControlName="blocked_add_channel">
                            <option [ngValue]="1">Yes</option>
                            <option [ngValue]="0">No</option>
                            <option *ngFor="let item of blocked_add_channel">
                                [ngValue]="item.blocked_add_channel">{{item.blocked_add_channel}}</option>
                        </select>
                          <br>

                    </form>

                            <button class="btn btn-primary me-1 mb-3" style="float: right;"
                                    (click)="CreateTelegramUser()">
                                Save
                            </button>

                        <div class="clearfix"></div>



<!--                                <form [formGroup]="addUserForm">-->
<!--                                    <h4>Add Details</h4>-->
<!--                                    <div class="form-group row">-->
<!--                                        <div class="col-xl-3 col-md-4"><label for="validationCustom0"><span>*</span>-->
<!--                                            Username</label></div>-->
<!--                                        <input type="text" formControlName="username" /> <br /><br />-->

<!--                                        <div class="col-xl-8 col-md-7"><input class="form-control"-->
<!--                                                                              id="validationCustom0"-->
<!--                                                                              type="text" required=""></div>-->
<!--                                    </div>-->
<!--                                    <div class="form-group row">-->
<!--                                        <div class="col-xl-3 col-md-4"><label for="validationCustom1"><span>*</span>-->
<!--                                            Mobile Number</label></div>-->
<!--                                        <input type="text" formControlName="mobilenumber" /> <br /><br />-->
<!--                                        <div class="col-xl-8 col-md-7"><input class="form-control"-->
<!--                                                                              id="validationCustom1"-->
<!--                                                                              type="text" required=""></div>-->
<!--                                    </div>-->
<!--                                    <div class="form-group row">-->
<!--                                        <div class="col-xl-3 col-md-4"><label for="validationCustom2"><span>*</span>-->
<!--                                            Status</label></div>-->
<!--                                        <input type="text" formControlName="status" /> <br /><br />-->
<!--                                        <div class="col-xl-8 col-md-7"><input class="form-control"-->
<!--                                                                              id="validationCustom2"-->
<!--                                                                              type="text" required=""></div>-->
<!--                                    </div>-->
<!--                                    <div class="form-group row">-->
<!--                                        <div class="col-xl-3 col-md-4"><label for="validationCustom3"><span>*</span>-->
<!--                                            Blocked Message</label>-->
<!--                                            <input type="text" formControlName="blocked_message" /> <br /><br />-->
<!--                                        </div>-->
<!--                                        <div class="col-xl-8 col-md-7"><input class="form-control"-->
<!--                                                                              id="validationCustom3"-->
<!--                                                                              type="text" required=""></div>-->
<!--                                    </div>-->
<!--                                    <div class="form-group row">-->
<!--                                        <div class="col-xl-3 col-md-4"><label for="validationCustom4"><span>*</span>-->
<!--                                            Blocked Add Channel</label></div>-->
<!--                                        <input type="text" formControlName="blocked_add_channel" /> <br /><br />-->
<!--                                        <div class="col-xl-8 col-md-7"><input class="form-control"-->
<!--                                                                              id="validationCustom4"-->
<!--                                                                              type="text" required=""></div>-->
<!--                                    </div>-->

<!--                                    <button class="btn btn-primary me-1 mb-3" style="float: right;"-->
<!--                                            (click)="CreateTelegramUser()">-->
<!--                                        Save-->
<!--                                    </button>-->
<!--                                </form>-->

               </div>
                </div>
            </div>
        </div>
    </div>

